module.exports = __webpack_public_path__ + "static/img/egg_b_06.fddce86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/b/egg_b_06.png
// module id = 6fyB
// module chunks = 1